import React, { useState, useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { setUserAddress } from "../../Redux/Actions";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MapItem from "../../components/MapItem/MapItem";
import MapModal from "../../components/MapModal/MapModal";
import Preloader from "../../components/Preloader/Preloader";
import { Config } from "../../Config";
import CartModal from "../../components/CartModal/CartModal";
import Skeleton from "react-loading-skeleton";
import "./ChangeAddress.scss";
import "./Responsive.scss";

const ChangeAddress = (props) => {
  let chooseAddress;
  if (props.location.state === undefined) {
    props.history.push("/");
  } else {
    chooseAddress = props.location.state.chooseAddress;
  }
  const [map, setMap] = useState([]);
  const [resetPage, setResetPage] = useState({ state: false, count: 0 });
  const [mapItemTitle, setMapItemTitle] = useState("");
  const [getMapDetailById, setGetMapDetailById] = useState();
  const [defaultCenter, setDefaultCenter] = useState([35.73853, 51.4326]);
  const [showModal, setShowModal] = useState(false);
  const [cartModal, setCartModal] = useState(false);
  const [preLoader, setPreLoader] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    Config.pageUp();
    if (user.length <= 0) {
      props.history.replace("/login");
    } else {
      getAllMaps();
    }
  }, [resetPage]);

  const getAllMaps = () => {
    if (resetPage.count === 0) {
      setPreLoader(true);
    }
    axios
      .get("/account/getaddress", {
        headers: {
          Authorization: "Bearer " + user[0]?.token,
        },
      })
      .then((result) => {
        if (result.data.status === 200) {
          setMap(result.data.data);
          setPreLoader(false);
        } else {
          setPreLoader(false);
        }
      })
      .catch((error) => {
        setPreLoader(false);
        // console.log(error);
      });
  };

  const setMarkerHandler = (e) => {
    // console.log(e);
  };

  const deleteMapHandler = (mapId) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);

    var raw = JSON.stringify({ Id: mapId });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(Config.apiPath + "/account/removeAddress", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          const userAddress = map.find((item) => item.id == mapId);
          const newUserAddress = Object.assign(user[0], {
            activeMapId: "",
            address: "",
            lat: "",
            lng: "",
          });
          if (userAddress) {
            dispatch(setUserAddress(newUserAddress));
          }
          toast.success(<div>{result.messages}</div>);
          setResetPage({ state: !resetPage.state, count: resetPage.count + 1 });
        } else {
          toast.error(<div>{result.messages}</div>);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const activeMapHandler = (mapId) => {
    const userAddress = map.find((item) => item.id == mapId);
    const newUserAddress = Object.assign(user[0], {
      activeMapId: userAddress.id,
      address: userAddress.address,
      lat: userAddress.lat,
      lng: userAddress.lng,
    });
    if (userAddress) {
      dispatch(setUserAddress(newUserAddress));
      if (chooseAddress) {
        setCartModal(true);
      } else {
        props.history.replace("/cart");
      }
    }
  };

  const editMapHandler = (mapId) => {
    setMapItemTitle("انتخاب و ویرایش آدرس");
    setGetMapDetailById(mapId);
    setDefaultCenter([]);
    setShowModal(true);
  };

  const addToMapModal = () => {
    setMapItemTitle("انتخاب و افزودن آدرس جدید");
    setGetMapDetailById(null);
    setDefaultCenter([35.73853, 51.4326]);
    setShowModal(true);
  };

  const submitMapHandler = (mobile, address, map) => {
    setShowSpinner(true);
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);

    let raw = JSON.stringify({
      Lat: map[0],
      Lng: map[1],
      Phone: mobile,
      Address: address,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(Config.apiPath + "/account/changeAddress", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          toast.success(<div>{result.messages}</div>);
          setShowSpinner(false);
          setShowModal(false);
          setResetPage({ state: !resetPage.state, count: resetPage.count + 1 });
        } else {
          toast.error(<div>{result.messages}</div>);
          setShowSpinner(false);
        }
      })
      .catch((error) => {
        setShowSpinner(false);
        // console.log(error);
        setShowModal(false);
      });
  };

  const updateMapHandler = (mobile, address, map, id) => {
    setShowSpinner(true);
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${user[0]?.token}`);

    let raw = JSON.stringify({
      Id: id,
      Lat: map[0],
      Lng: map[1],
      Phone: mobile,
      Address: address,
    });

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(Config.apiPath + "/account/changeAddress", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === 200) {
          toast.success(<div>{result.messages}</div>);
          setShowSpinner(false);
          setShowModal(false);
          setResetPage({ state: !resetPage.state, count: resetPage.count + 1 });
        } else {
          toast.error(<div>{result.messages}</div>);
          setShowSpinner(false);
        }
      })
      .catch((error) => {
        setShowSpinner(false);
        // console.log(error);
        setShowModal(false);
      });
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const closeCartModal = () => {
    setCartModal(false);
  };

  const showCartHandler = () => {
    props.history.push("/cart");
    setCartModal(false);
  };

  return (
    <section className="ChangeAddressWrapper mobile">
      <Helmet>
        {/* <title>ایران رگالو | تغییر آدرس</title> */}
        <title>{Config.helmetTitle} | تغییر آدرس</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      {cartModal && <CartModal title="انتخاب آدرس" closeCartModal={closeCartModal} showCartHandler={showCartHandler} />}
      {/* {preLoader && <Preloader active={preLoader} />} */}
      {/* <ToastContainer autoClose={5000} rtl={true} position="bottom-right" /> */}
      <div className="addressContent">
        <div className="desktop">
          <div className="boxAddress">
            <div className="header">
              <p className="title">انتخاب و تغییر آدرس</p>
              {map.length < 3 && (
                <span className="addMap" onClick={addToMapModal}>
                  <FaPlus />
                </span>
              )}
            </div>
            <div className="mapBox">
              {!preLoader ? (
                map.map((item, index) => {
                  return (
                    <MapItem
                      key={index}
                      defaultCenter={[item.lat, item.lng]}
                      anchor={[item.lat, item.lng]}
                      height={250}
                      zoom={14}
                      mapId={item.id}
                      address={item.address}
                      setMarkerHandler={setMarkerHandler}
                      deleteMapHandler={deleteMapHandler}
                      editMapHandler={editMapHandler}
                      activeMapHandler={activeMapHandler}
                      active={user[0]?.activeMapId === item.id ? true : false}
                      twoFingerDrag={true}
                    />
                  );
                })
              ) : (
                <>
                  <Skeleton
                    containerClassName="mapItem"
                    className="skeleton"
                    highlightColor={Config.skeletonHighlightColor}
                  />
                  <Skeleton
                    containerClassName="mapItem"
                    className="skeleton"
                    highlightColor={Config.skeletonHighlightColor}
                  />
                </>
              )}
              {map.length == 0 && !preLoader && (
                <div className="noAddress">
                  <p className="noAddressText" style={{ color: "rgba(0,0,0,0.5)" }}>
                    لطفا یک آدرس اضافه کنید
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <MapModal
          title={mapItemTitle}
          defaultCenter={defaultCenter}
          showSpinner={showSpinner}
          submitMapHandler={submitMapHandler}
          updateMapHandler={updateMapHandler}
          closeModal={closeModal}
          getMapDetailById={getMapDetailById}
        />
      )}
    </section>
  );
};

export default React.memo(withRouter(ChangeAddress));
